export default __webpack_public_path__ + "static/media/Breeches of the Howling Giant.61596234.jpg";